// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1loNE","title":"Info_title__10Dwr","links":"Info_links__3m4gd","link":"Info_link__3V3bY","logo":"Info_logo__3kchB"};